import { useDispatch } from 'react-redux'
import React, { useState } from 'react'
import * as rest from '../../../services'
import { showErrorToast, showSuccessToast } from '../../../state/toasts'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../../components'

export const SendStatusUpdateByEmail = ({ ticket }) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const send = () => {
    setLoading(true)
    new rest.TicketService(ticket.url)
      .send_ticket_status_by_email()
      .then(() => {
        setLoading(false)
        dispatch(showSuccessToast('Sent Ticket Status By Email'))
      })
      .catch((error) => {
        setLoading(false)
        dispatch(showErrorToast('Could not Send Status Details By Email'))
      })
  }
  return (
    <ReactBootstrap.Dropdown.Item
      onClick={() => send()}
      block
      variant="outline-success"
    >
      {loading ? <components.Loading /> : ' Send Status Update By Email'}
    </ReactBootstrap.Dropdown.Item>
  )
}


export const SendEstimationsByEmail = ({ ticket }) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const send = () => {
    setLoading(true)
    new rest.TicketService(ticket.url)
      .send_estimation_pdf()
      .then(() => {
        setLoading(false)
        dispatch(showSuccessToast('Sent Ticket Estimations By Email'))
      })
      .catch((error) => {
        setLoading(false)
        dispatch(showErrorToast('Could not Send Estimations By Email'))
      })
  }
  return (
    <ReactBootstrap.Button
      onClick={() => send()}
      block
      variant="dark"
    >
      {loading ? <components.Loading /> : ' Send Estimations By Email'}
    </ReactBootstrap.Button>
  )
}
